import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListService } from 'src/services/process-list.service';
import { CdkDragDrop, CdkDragStart, moveItemInArray, transferArrayItem, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-paineladm',
  templateUrl: './paineladm.component.html',
  styleUrls: ['./paineladm.component.scss']
})
export class PaineladmComponent implements OnInit {
  displayedColumns: string[] = ['status', 'name', 'created_at', 'show', 'order'];

  dataSource: MatTableDataSource<any>
  processLists

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('table', { static: true }) table: MatTable<any>;

  dragDisabled = true;
  isChecked = true;

  constructor( 
    private http: HttpService,
    private errorReport: ErrorReportService,
  ) {}

  ngOnInit(): void {
    this.getProcessList();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getProcessList() {
    const user = JSON.parse(localStorage.getItem('token'));
    this.http.get('process_list_all')
      .subscribe(
        (result: any) => {
          this.processLists = result.data;
          this.dataSource = new MatTableDataSource(this.processLists);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        },
        err => this.errorReport.showMessage(err)
      )
  }

  drop(event: CdkDragDrop<any[]>) {
    // Return the drag container to disabled.
    this.dragDisabled = true;
    const previousIndex = this.processLists.findIndex((d) => d === event.item.data);
    moveItemInArray(this.processLists, previousIndex, event.currentIndex);
    this.processLists.forEach((process, idx) => {
      process.order = idx + 1;
    });
    this.table.renderRows();
    this.dataSource = new MatTableDataSource(this.processLists);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  Salvar(){
    this.processLists.forEach((process, idx) => {
      // console.log(process.id+' - '+process.name+' = posição '+Number(Number(idx) + 1));
      process.order = idx + 1;
      
      this.http.save('process_list_all:update',{id:process.id, order:process.order, show: process.show})
        .subscribe(
          (result: any) => {
            // console.log(result)
          },
          err => this.errorReport.showMessage(err)
        )
    });
  }
  
}
